module.exports = {
	"dk": {
		"test": {
			"server": "5d401.v.fwmrm.net",
			"networkId": "381954"
		},
		"special": {
			"server": "5d402.v.fwmrm.net",
			"networkId": "381954"
		},
		"prod": {
			"server": "5d402.v.fwmrm.net",
			"networkId": "381954"
		},
		"adUnits": {
			"Panorama": {
				"mobile": {
					"Mobile Panorama 320x50": [
						{
							"width": 320,
							"height": 50
						}
					],
					"Mobile Panorama 320x80": [
						{
							"width": 320,
							"height": 80
						}
					],
					"Mobile Panorama 320x160": [
						{
							"width": 320,
							"height": 160
						}
					],
					"Mobile Panorama 320x320": [
						{
							"width": 320,
							"height": 320
						}
					],
					"Mobile Panorama 320x339": [
						{
							"width": 320,
							"height": 339
						}
					],
					"Mobile Panorama 339x339": [
						{
							"width": 339,
							"height": 339
						}
					]
				},
				"tabletPortrait": {
					"Tablet Leaderboard 728x90": [
						{
							"width": 728,
							"height": 90
						}
					],
					"Tablet Panorama Portrait 768x562": [
						{
							"width": 768,
							"height": 562
						}
					]
				},
				"tabletLandscape": {
					"Tablet Leaderboard 728x90": [
						{
							"width": 728,
							"height": 90
						}
					],
					"Tablet Panorama Landscape 1024x384": [
						{
							"width": 1024,
							"height": 384
						}
					]
				},
				"desktop": {
					"Desktop Panorama 930x120": [
						{
							"width": 930,
							"height": 120
						}
					],
					"Desktop Panorama 930x180": [
						{
							"width": 930,
							"height": 180
						}
					],
					"Desktop Panorama 980x240": [
						{
							"width": 980,
							"height": 240
						}
					],
					"Desktop Panorama 980x360": [
						{
							"width": 980,
							"height": 360
						}
					]
				}
			},
			"Insider": {
				"mobile": {
					"Mobile Insider 320x50": [
						{
							"width": 320,
							"height": 50
						}
					],
					"Mobile Insider 320x80": [
						{
							"width": 320,
							"height": 80
						}
					],
					"Mobile Insider 320x160": [
						{
							"width": 320,
							"height": 160
						}
					],
					"Mobile Insider 320x320": [
						{
							"width": 320,
							"height": 320
						}
					],
					"Mobile Insider 320x339": [
						{
							"width": 320,
							"height": 339
						}
					],
					"Mobile Insider 339x339": [
						{
							"width": 339,
							"height": 339
						}
					]
				},
				"tabletPortrait": {
					"Tablet Insider 339x339": [
						{
							"width": 339,
							"height": 339
						}
					]
				},
				"tabletLandscape": {
					"Tablet Insider 300x250": [
						{
							"width": 300,
							"height": 250
						}
					]
				},
				"desktop": {
					"Desktop Insider 300x250": [
						{
							"width": 300,
							"height": 250
						}
					],
					"Desktop Insider 320x320": [
						{
							"width": 320,
							"height": 320
						}
					],
					"Desktop Insider 320x339": [
						{
							"width": 320,
							"height": 339
						}
					],
					"Desktop Insider 339x339": [
						{
							"width": 339,
							"height": 339
						}
					],
					"Desktop Insider 320x160": [
						{
							"width": 320,
							"height": 160
						}
					],
					"Desktop Insider 600x250": [
						{
							"width": 600,
							"height": 250
						}
					]
				}
			},
			"Takeover": {
				"desktop": {
					"Desktop Takeover 2560x1440": [
						{
							"width": 2560,
							"height": 1440
						}
					]
				}
			},
			"Skyscraper": {},
			"Ticker": {
				"mobile": {
					"Mobile Ticker 320x35": [
						{
							"width": 320,
							"height": 35
						}
					],
					"Mobile Ticker 768x35": [
						{
							"width": 768,
							"height": 35
						}
					],
					"Mobile Ticker 768x26": [
						{
							"width": 768,
							"height": 26
						}
					]
				},
				"tabletPortrait": {
					"Tablet Ticker 1378x26": [
						{
							"width": 1378,
							"height": 26
						}
					],
					"Tablet Ticker 1200x26": [
						{
							"width": 1200,
							"height": 26
						}
					]
				},
				"tabletLandscape": {
					"Tablet Ticker 1378x26": [
						{
							"width": 1378,
							"height": 26
						}
					],
					"Tablet Ticker 1200x26": [
						{
							"width": 1200,
							"height": 26
						}
					]
				},
				"desktop": {
					"Desktop Ticker 1378x26": [
						{
							"width": 1378,
							"height": 26
						}
					],
					"Desktop Ticker 2560x26": [
						{
							"width": 2560,
							"height": 26
						}
					]
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/adConfig.json
// module id = 954
// module chunks = 0 1 2